import { createAction, props } from '@ngrx/store';
import { SupportAccessModel } from '@models/support-access.model';

export const resetToInitialState = createAction('[SUPPORT-ACCESS] Reset To Initial State');

export const getSupportAccess = createAction('[SUPPORT-ACCESS] Get Support Access');
export const getSupportAccessSuccess = createAction(
  '[SUPPORT-ACCESS] Get Support Access Success',
  props<{ documents: SupportAccessModel.Document[] }>(),
);
export const getSupportAccessFail = createAction('[SUPPORT-ACCESS] Get Support Access Fail');

export const getAllSupportAccess = createAction('[SUPPORT-ACCESS] Get All Support Access');
export const getAllSupportAccessSuccess = createAction(
  '[SUPPORT-ACCESS] Get All Support Access Success',
  props<{ documents: SupportAccessModel.Document[] }>(),
);
export const getAllSupportAccessFail = createAction('[SUPPORT-ACCESS] Get All Support Access Fail');

export const createSupportAccess = createAction(
  '[SUPPORT-ACCESS] Create Support Access',
  props<{ body: SupportAccessModel.CreateRequest }>(),
);
export const createSupportAccessSuccess = createAction('[SUPPORT-ACCESS] Create Support Access Success');
export const createSupportAccessFail = createAction('[SUPPORT-ACCESS] Create Support Access Fail');

export const updateSupportAccess = createAction(
  '[SUPPORT-ACCESS] Update Support Access',
  props<{ id: string; body: SupportAccessModel.UpdateRequest }>(),
);
export const updateSupportAccessSuccess = createAction(
  '[SUPPORT-ACCESS] Update Support Access Success',
  props<{ document: SupportAccessModel.Document }>(),
);
export const updateSupportAccessFail = createAction('[SUPPORT-ACCESS] Update Support Access Fail');

export const updateSupportAccessEnabled = createAction(
  '[SUPPORT-ACCESS] Update Support Access Enabled',
  props<{ id: string; body: SupportAccessModel.UpdateEnabledRequest; previousEnabled: boolean }>(),
);
export const updateSupportAccessEnabledSuccess = createAction(
  '[SUPPORT-ACCESS] Update Support Access Enabled Success',
  props<{ document: SupportAccessModel.Document }>(),
);
export const updateSupportAccessEnabledFail = createAction(
  '[SUPPORT-ACCESS] Update Support Access Enabled Fail',
  props<{ id: string; previousEnabled: boolean }>(),
);

export const deleteSupportAccess = createAction(
  '[SUPPORT-ACCESS] Delete Support Access',
  props<{ id: string }>(),
);
export const deleteSupportAccessSuccess = createAction(
  '[SUPPORT-ACCESS] Delete Support Access Success',
  props<{ id: string }>(),
);
export const deleteSupportAccessFail = createAction('[SUPPORT-ACCESS] Delete Support Access Fail');

export const updateSupportAccessStore = createAction(
  '[SUPPORT-ACCESS] Update Support Access Store',
  props<{ id: string; document: Partial<SupportAccessModel.Document> }>(),
);
